import React from 'react';
import './SampleTable.css';
// import { debounce } from 'lodash';
import { SampleInfo } from './Utils';


type SampleTableProps = {
  data: Array<SampleInfo>,
  dataset: string,
}
type SampleTableState = {index: number};
class SampleTableComponent extends React.Component<SampleTableProps, SampleTableState> {
  constructor(props: SampleTableProps) {
    super(props);
    this.state = { index: Math.floor(Math.random() * this.props.data.length) };
  }

  handleStateChange(event: any) { // KeyboardEvent
    // this.setState({ text: event.target.value });
  }

  changeIndex(incr: number) {
    this.setState({ index: (this.state.index + incr + this.props.data.length) % this.props.data.length });
  }


  // componentDidUpdate(oldProps: SampleTableProps) {
  //   if (oldProps.text !== this.props.text) {
  //     // this.setState({
  //     //   text: this.props.text
  //     // });
  //   }
  // }

  render() {
    const dataset = this.props.dataset;
    // matches generate_axis_evals.json
    const ref_heading: string = ({
      tldr:"Human-written reference TL;DR", cnndm:"Human-written reference summary"
    } as any)[dataset];
    const data = this.props.data[this.state.index];
    console.log(data)
    let post_div = (<div>ERROR, UNKNOWN DATASET</div>);
    if (dataset === 'tldr') {
      post_div = (
        <div>
          <b>Reddit Post</b>
          <br/>
          <br/>
          <i>Subreddit</i>: /r/{data.info.subreddit}
          <br/>
          <i>Title</i>: {data.info.title}
          <br/>
          <br/>
            {data.info.post.split('\n').map((item: string, key: number) => {
              return <span key={key}>{item}<br/></span>
            })}
        </div>
      )
    } else if (dataset === 'cnndm') {
      post_div = (
        <div>
          <b>News Article</b>
          <br/>
          <br/>
          <i>Site</i>: {data.info.site}
          <br/>
          <i>Title</i>: {data.info.title}
          <br/>
          <br/>
            {data.info.article.split('\n').map((item: string, key: number) => {
              return <span key={key}>{item}<br/></span>
            })}
        </div>
      )
    }


    return (
      <div className="sample-carousel">
        <div>
          <button className="sample-next" onClick={() => {this.changeIndex(1)}}>Next &raquo;</button>
          <button className="sample-previous" onClick={() => {this.changeIndex(-1)}}>&laquo; Previous</button>
        </div>
        <div className='sample-table' style={{display: "flex", flexDirection: "row", margin: '10px 0px' }}>
          <div className="table-post" style={{flexBasis: "65%", flexGrow: 0}}>
            {post_div}
          </div>
          <div className="table-summaries" style={{flexBasis: "35%", flexGrow: 0, display: "flex", flexDirection: "column"}}>
            <div className="table-summary table-summary-ref">
              <b>{ref_heading}</b>
              <br/>
              <br/>
              {data.info.reference}
            </div>
            {
              Object.entries(data.samples).map(([name, sample]) => {
                return (
                  <div key={name} className="table-summary">
                  <b>{name}</b>
                  <br/>
                  <br/>
                  {sample}
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="hidden">
          <button className="sample-next" onClick={() => {this.changeIndex(1)}}>Next &raquo;</button>
          <button className="sample-previous" onClick={() => {this.changeIndex(-1)}}>&laquo; Previous</button>
        </div>
      </div>
    );
  }
}

export default SampleTableComponent;
